import styled from 'styled-components';

import { Link } from '../Link/Link';

export const Root = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  /* width: 286px; */
  text-align: center;
`;

export const ImageContainer = styled(Link)`
  position: relative;
  padding: 25px 12px 0;
`;

export const ImageCorner = styled.svg`
  position: absolute;
  top: 25px;
  left: 12px;
`;

export const Image = styled.img`
  flex-shrink: 0;
  width: 100%;
  object-fit: cover;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h5`
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
`;

export const Desc = styled.span`
  display: block;
  margin: 6px 0 12px;
  padding: 0 24px;
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;

export const Cta = styled(Link)`
  display: flex;
  align-items: center;
  gap: 7px;
  width: fit-content;
  height: 32px;
  padding: 0 12px 0 20px;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  border: 0 none;
  border-radius: 16px;
  transition: all 150ms;
`;
